import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Award, Users, Palette } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();

  const stats = [
    { icon: Award, value: '5+', label: t.about.experience },
    { icon: Users, value: '500+', label: t.about.clients },
    { icon: Palette, value: '1000+', label: t.about.designs },
  ];

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-rose-50/50 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_nailsbymoncton/artifacts/rm9zpz0k_WhatsApp%20Image%202025-12-13%20%C3%A0%2001.14.33_9571c78b.jpg"
                alt="Anastasiya - Nail Master"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-rose-200 rounded-2xl -z-10" />
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-rose-100 rounded-full -z-10" />
          </div>

          {/* Content Side */}
          <div className="lg:pl-8">
            <span className="text-rose-400 text-sm tracking-widest uppercase font-medium">
              {t.about.subtitle}
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-stone-800 mt-3 mb-6">
              {t.about.title}
            </h2>
            <div className="w-16 h-1 bg-rose-300 mb-8" />
            
            <p className="text-stone-600 text-lg leading-relaxed mb-10">
              {t.about.description}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="text-center p-4 bg-stone-50 rounded-xl hover:bg-rose-50 transition-colors duration-300 group"
                >
                  <stat.icon className="w-6 h-6 text-rose-400 mx-auto mb-2 group-hover:scale-110 transition-transform" />
                  <div className="text-2xl font-semibold text-stone-800">{stat.value}</div>
                  <div className="text-xs text-stone-500 uppercase tracking-wide mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
